import { cva } from "../../styled-system/css";

export const tableWrapper = cva({
  base: {
    width: '100%',
    overflowX: 'auto',
    backgroundColor: 'surface.primary',
    borderRadius: '8px',
    border: '1px solid',
    borderColor: 'border.secondary',
    position: 'relative',
  }
});

export const table = cva({
  base: {
    width: '100%',
    borderCollapse: 'collapse',
  }
});

export const tableHead = cva({
  base: {
    color: 'text.secondary',
    fontSize: '14px',
    fontWeight: '400',
    height: '48px',
    textAlign: 'left',
  },
  variants: {
    disabled: {
      true: {
        backgroundColor: 'surface.disable',
        color: 'text.disable',
      }
    }
  }
});

export const tableHeadCell = cva({
  base: {
    padding: '0 24px',
    whiteSpace: 'nowrap',
  },
});

export const tableRow = cva({
  base: {
    backgroundColor: {
      base: 'transparent',
    },
    color: 'text.primary',
    fontSize: '14px',
    fontWeight: '400',
    height: '48px',
    borderTop: '1px solid',
    borderColor: 'border.secondary',
  }
});

export const tableCell = cva({
  base: {
    padding: '0 24px',
  },
});

export const paymentDetailTableRow = cva({
  base: {
    backgroundColor: {
      base: 'transparent',
    },
    color: 'text.primary',
    fontSize: '14px',
    fontWeight: '400',
    borderTop: 'none',
    borderColor: 'border.secondary',
  },
  variants: {
    loc: {
      firstInGroup: {
        borderTop: '1px solid',
      },
      lastInGroup: {
      },
      single: {
        borderTop: '1px solid',
      }
    }
  }
});

export const paymentDetailTableCell = cva({
  // 複数行の payment detail を上揃えにする
  base: {
    padding: '8px 24px',
    fontSize: '14px',
    verticalAlign: 'top',
  },
  variants: {
    loc: {
      firstInGroup: {
        paddingTop: '12px',
      },
      lastInGroup: {
        paddingBottom: '12px',
      },
      single: {
        paddingTop: '12px',
        paddingBottom: '12px',
      }
    }
  }
});